<script setup>
</script>

<template>

<div class="weather">
  <iframe src="https://i.tianqi.com/?c=code&a=getcode&id=7&color=%23FFFFFF&icon=1"></iframe>
</div>

</template>

<style lang="less" scoped>

.weather {
  padding: 20px;
  
  iframe {
    width: 250px;
    height: 130px;
    border: none;
  }
}

</style>